/**
 * <ClassInfo />
 *
 * Pass data (object) then fields (object).
 *
 * fields structure:
 *
 * fields = {
 *   studentName: {
 *      title: __('Student Name'),
 *      className: 'student-name',
 *      hide: true, // if true, it will hide. Use it for conditional rendering.
 *      render: (opts)=>{ return <CustomField />; } // a callback function when you can return "customized" field value
 *   }
 * }
 *
 * Example:
 *
 * const FIELDS = {
 *   totalPrice: {
 *     title: __('Class Price', 'classdetail'),
 *     render: (opts)=>{
 *       // render() is used only if you wanted to modify value.
 *       //
 *       return '$' + opts.value;
 *     }
 *   }
 * }
 *
 * <ClassInfoDisplay data={classInfo} fields={FIELDS} />
 *
 *
 * @parent anybody
 * @stateless
 */
import React, { PropTypes } from 'react';
import InfoField from 'components/UI/InfoField';
import forOwn from 'lodash/forOwn';
import '../InfoDisplay.scss';

class ClassInfo extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    let Fields = [];

    let {
      data,
      fields,
    } = this.props;

    forOwn(fields, (field, key)=>{
      if (field.hide !== true) {

        let value;
        if (typeof field.render == 'function') {
          value = field.render({...this.props, value: data[key], field });
        } else {
          value = data[key] || '';
        }

        Fields.push(
          <InfoField
            className={field.className || 'col-sm-3'}
            label={field.title}
            value={value || ''} 
            key={key} />
          );
      }
    });

    return (
      <div className='info-display class-info-display'>
        {Fields}
      </div>
    );
  }
}

export default ClassInfo;



// WEBPACK FOOTER //
// ./src/template/InfoDisplays/ClassInfo/index.js